import React from "react";
import CloseIcon from "../Assets/svgs/CloseIcon";
import ExclamationMarkIcon from "../Assets/svgs/ExclamationMarkIcon";

const NoPlanModal = ({ onClose, onPressAddPlan }) => {
  return (
    <div className="modal modal--modalCredits modal--open">
      <div className="modal__dialog">
        <div className="modal__content">
          <div className="modal__header">
            <button className="btn btn__transparent btnClose" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
          <div className="modal__body">
            <span className="icon">
              <ExclamationMarkIcon />
            </span>
            <h4 className="title title--h3">No Plan Found!</h4>
            <p className="para">
              Please add plan to view the Plan
              <br />
              Summary
            </p>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button className="btn btn__primary" onClick={onPressAddPlan}>
                Add Plan
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default NoPlanModal;
